import { OnInit, Component, AfterViewInit, Input, Output, EventEmitter } from "@angular/core";
import { ConfigModel } from "src/app/models/graphs.model";
import { Observable } from "rxjs";
import { GraphService } from "src/app/services/graphs.service";
import * as Highcharts from "highcharts";

@Component({
    selector: 'app-ops-wells-drilled-and-connected',
    templateUrl: './wellsdrilledandconnected.component.html',
    styleUrls: ['../../home/home.component.scss']
})

export class WellsDrilledandConnectedComponent implements OnInit, AfterViewInit {
    Highcharts = Highcharts;
    cooperMax: number;
    GLNGMax: number;
    subHeading1: string[];
    subHeading2: any;

    graphService: Observable<any>;
    graphData: ConfigModel = new ConfigModel();
    opsChart: Object;

    @Input() ops_CurrentMonth: number;
    @Input() ops_CurrentYear: number;
    @Input() ops_Drilled_Cooper_Target: number;
    @Input() ops_Drilled_Cooper_LastYear: number;
    @Input() ops_Drilled_Cooper_Jan: number;
    @Input() ops_Drilled_Cooper_Feb: number;
    @Input() ops_Drilled_Cooper_Mar: number;
    @Input() ops_Drilled_Cooper_Apr: number;
    @Input() ops_Drilled_Cooper_May: number;
    @Input() ops_Drilled_Cooper_Jun: number;
    @Input() ops_Drilled_Cooper_Jul: number;
    @Input() ops_Drilled_Cooper_Aug: number;
    @Input() ops_Drilled_Cooper_Sep: number;
    @Input() ops_Drilled_Cooper_Oct: number;
    @Input() ops_Drilled_Cooper_Nov: number;
    @Input() ops_Drilled_Cooper_Dec: number;
    @Input() ops_Drilled_GLNG_Target: number;
    @Input() ops_Drilled_GLNG_LastYear: number;
    @Input() ops_Drilled_GLNG_Jan: number;
    @Input() ops_Drilled_GLNG_Feb: number;
    @Input() ops_Drilled_GLNG_Mar: number;
    @Input() ops_Drilled_GLNG_Apr: number;
    @Input() ops_Drilled_GLNG_May: number;
    @Input() ops_Drilled_GLNG_Jun: number;
    @Input() ops_Drilled_GLNG_Jul: number;
    @Input() ops_Drilled_GLNG_Aug: number;
    @Input() ops_Drilled_GLNG_Sep: number;
    @Input() ops_Drilled_GLNG_Oct: number;
    @Input() ops_Drilled_GLNG_Nov: number;
    @Input() ops_Drilled_GLNG_Dec: number;
    @Input() ops_Drilled_Max: number;
    @Input() ops_Drilled_SubHeading: string;

    @Output() drilled_SubHeading = new EventEmitter();

    constructor(private graph: GraphService) {
        this.graphData = new ConfigModel();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.load();
        })
    }

    ngOnInit(): void {
    }

    load() {

        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;            
            
            let arrCooper: any[] = [];

            arrCooper[0] = this.graphData.ops_Drilled_Cooper_Dec;
            arrCooper[1] = this.graphData.ops_Drilled_Cooper_Nov;
            arrCooper[2] = this.graphData.ops_Drilled_Cooper_Oct;
            arrCooper[3] = this.graphData.ops_Drilled_Cooper_Sep;
            arrCooper[4] = this.graphData.ops_Drilled_Cooper_Aug;
            arrCooper[5] = this.graphData.ops_Drilled_Cooper_Jul;
            arrCooper[6] = this.graphData.ops_Drilled_Cooper_Jun;
            arrCooper[7] = this.graphData.ops_Drilled_Cooper_May;
            arrCooper[8] = this.graphData.ops_Drilled_Cooper_Apr;
            arrCooper[9] = this.graphData.ops_Drilled_Cooper_Mar;
            arrCooper[10] = this.graphData.ops_Drilled_Cooper_Feb;
            arrCooper[11] = this.graphData.ops_Drilled_Cooper_Jan;
            let maxCooper = arrCooper[0];
            for (var i = 0; i < arrCooper.length; i++) {
                if (arrCooper[i] > maxCooper)
                    maxCooper = arrCooper[i];
            }
            this.cooperMax = maxCooper;

            let arrGLNG: any[] = [];

            arrGLNG[0] = this.graphData.ops_Drilled_GLNG_Dec;
            arrGLNG[1] = this.graphData.ops_Drilled_GLNG_Nov;
            arrGLNG[2] = this.graphData.ops_Drilled_GLNG_Oct;
            arrGLNG[3] = this.graphData.ops_Drilled_GLNG_Sep;
            arrGLNG[4] = this.graphData.ops_Drilled_GLNG_Aug;
            arrGLNG[5] = this.graphData.ops_Drilled_GLNG_Jul;
            arrGLNG[6] = this.graphData.ops_Drilled_GLNG_Jun;
            arrGLNG[7] = this.graphData.ops_Drilled_GLNG_May;
            arrGLNG[8] = this.graphData.ops_Drilled_GLNG_Apr;
            arrGLNG[9] = this.graphData.ops_Drilled_GLNG_Mar;
            arrGLNG[10] = this.graphData.ops_Drilled_GLNG_Feb;
            arrGLNG[11] = this.graphData.ops_Drilled_GLNG_Jan;
            let maxGLNG = arrGLNG[0];

            for (var i = 0; i < arrGLNG.length; i++) {
                if (arrGLNG[i] > maxGLNG)
                    maxGLNG = arrGLNG[i];
            }
            this.GLNGMax = maxGLNG;
            
            this.checkNullOrBlankValues();

            this.opsWellsDrilledandConnected();
        });
    }

    refresh() {

        this.graphData.ops_Drilled_Cooper_Target = this.ops_Drilled_Cooper_Target;
        this.graphData.ops_Drilled_Cooper_LastYear = this.ops_Drilled_Cooper_LastYear;
        this.graphData.ops_Drilled_Cooper_Jan = this.ops_Drilled_Cooper_Jan;
        this.graphData.ops_Drilled_Cooper_Feb = this.ops_Drilled_Cooper_Feb;
        this.graphData.ops_Drilled_Cooper_Mar = this.ops_Drilled_Cooper_Mar;
        this.graphData.ops_Drilled_Cooper_Apr = this.ops_Drilled_Cooper_Apr;
        this.graphData.ops_Drilled_Cooper_May = this.ops_Drilled_Cooper_May;
        this.graphData.ops_Drilled_Cooper_Jun = this.ops_Drilled_Cooper_Jun;
        this.graphData.ops_Drilled_Cooper_Jul = this.ops_Drilled_Cooper_Jul;
        this.graphData.ops_Drilled_Cooper_Aug = this.ops_Drilled_Cooper_Aug;
        this.graphData.ops_Drilled_Cooper_Sep = this.ops_Drilled_Cooper_Sep;
        this.graphData.ops_Drilled_Cooper_Oct = this.ops_Drilled_Cooper_Oct;
        this.graphData.ops_Drilled_Cooper_Nov = this.ops_Drilled_Cooper_Nov;
        this.graphData.ops_Drilled_Cooper_Dec = this.ops_Drilled_Cooper_Dec;
        this.graphData.ops_Drilled_GLNG_Target = this.ops_Drilled_GLNG_Target;
        this.graphData.ops_Drilled_GLNG_LastYear = this.ops_Drilled_GLNG_LastYear;
        this.graphData.ops_Drilled_GLNG_Jan = this.ops_Drilled_GLNG_Jan;
        this.graphData.ops_Drilled_GLNG_Feb = this.ops_Drilled_GLNG_Feb;
        this.graphData.ops_Drilled_GLNG_Mar = this.ops_Drilled_GLNG_Mar;
        this.graphData.ops_Drilled_GLNG_Apr = this.ops_Drilled_GLNG_Apr;
        this.graphData.ops_Drilled_GLNG_May = this.ops_Drilled_GLNG_May;
        this.graphData.ops_Drilled_GLNG_Jun = this.ops_Drilled_GLNG_Jun;
        this.graphData.ops_Drilled_GLNG_Jul = this.ops_Drilled_GLNG_Jul;
        this.graphData.ops_Drilled_GLNG_Aug = this.ops_Drilled_GLNG_Aug;
        this.graphData.ops_Drilled_GLNG_Sep = this.ops_Drilled_GLNG_Sep;
        this.graphData.ops_Drilled_GLNG_Oct = this.ops_Drilled_GLNG_Oct;
        this.graphData.ops_Drilled_GLNG_Nov = this.ops_Drilled_GLNG_Nov;
        this.graphData.ops_Drilled_GLNG_Dec = this.ops_Drilled_GLNG_Dec;
        this.graphData.ops_Drilled_Max = this.ops_Drilled_Max;

        if(this.ops_Drilled_SubHeading) {
            this.ops_Drilled_SubHeading = this.ops_Drilled_SubHeading.replace("\n", "<br>");
        }
        this.graphData.ops_Drilled_SubHeading = this.ops_Drilled_SubHeading;

        this.checkNullOrBlankValues();

        this.opsWellsDrilledandConnected();
    }

    opsWellsDrilledandConnected() {

        this.opsChart = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "spline",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            title: {
                text: 'Wells drilled & connected',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: this.graphData.ops_Drilled_SubHeading, //'Cooper: 7 connected YTD<br>GLNG: 5 connected YTD',
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Target'],
                allowDecimals: false,
                tickInterval: 1,
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
            },
            yAxis: [{
                title: {
                    text: 'Wells Drilled',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.ops_Drilled_Max,
                tickInterval: 50,
                minorTickInterval: 50,
                majorTickInterval: 50,
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                },
            }],
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    },
                    enableMouseTracking: false
                },
                spline: {
                    marker: {
                        radius: 4,
                        lineColor: '#666666',
                        lineWidth: 1,

                    }
                }
            },
            tooltip: {
                formatter: function () {
                    var area = 'Cooper';
                    if (this.series.name.indexOf('GLNG') > -1)
                        area = 'GLNG';
                    var d = new Date();
                    var n = d.getFullYear();
                    if (this.x == 'Target') {
                        return '<b>' + area + '</b> target for ' + n + ': <b>' + this.y + '</b>';
                    }
                    if (this.series.name.indexOf('' + n) == -1) {
                        // Single line
                        return '<b>' + area + '</b> wells drilled ' + '' + (n - 1) + ': <b>' + this.y + '</b>';
                    }
                    return '<b>' + area + '</b> wells drilled ' + this.x + ' ' + n + ': <b>' + this.y + '</b>';
                }
            },
            series: [
                {
                    name: this.graphData.ops_CurrentYear - 1 + ' Cooper - ' + this.graphData.ops_Drilled_Cooper_LastYear + ' Wells',
                    dashStyle: 'shortdot',
                    marker: {
                        enabled: false
                    },
                    data: [this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear,
                    this.graphData.ops_Drilled_Cooper_LastYear]
                },
                {
                    name: this.graphData.ops_CurrentYear + ' Cooper - ' + this.cooperMax + ' Wells',
                    marker: {
                        symbol: 'diamond'
                    },
                    data:
                        [
                            {
                                y: this.graphData.ops_Drilled_Cooper_Jan,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Jan == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Feb,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Feb == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Mar,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Mar == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Apr,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Apr == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_May,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_May == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Jun,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Jun == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Jul,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Jul == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Aug,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Aug == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Sep,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Sep == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Oct,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Oct == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Nov,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Nov == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Dec,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_Cooper_Dec == this.cooperMax),
                                    symbol: 'diamond'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_Cooper_Target,
                                marker: { symbol: 'url(assets/images/target1.png)' }
                            }
                        ]
                },
                {
                    name: this.graphData.ops_CurrentYear - 1 + ' GLNG - ' + this.graphData.ops_Drilled_GLNG_LastYear + ' Wells',
                    dashStyle: 'shortdot',
                    marker: {
                        enabled: false
                    },
                    data: [this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear,
                    this.graphData.ops_Drilled_GLNG_LastYear]
                },
                {
                    name: this.graphData.ops_CurrentYear + ' GLNG - ' + this.GLNGMax + ' Wells',
                    marker: {
                        symbol: 'square'
                    },
                    data:
                        [
                            {
                                y: this.graphData.ops_Drilled_GLNG_Jan,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Jan == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Feb,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Feb == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Mar,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Mar == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Apr,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Apr == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_May,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_May == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Jun,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Jun == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Jul,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Jul == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Aug,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Aug == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Sep,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Sep == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Oct,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Oct == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Nov,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Nov == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Dec,
                                marker: {
                                    enabled: (this.graphData.ops_Drilled_GLNG_Dec == this.GLNGMax),
                                    symbol: 'square'
                                },
                            },
                            {
                                y: this.graphData.ops_Drilled_GLNG_Target,
                                marker: { symbol: 'url(assets/images/target2.png)' }
                            }
                        ]
                },
            ],
            colors: ["#0088CE", "#0088CE", "#00A739", "#00A739"]
        };
    }

    checkNullOrBlankValues() {

        var x1 = this.graphData.ops_Drilled_Cooper_Target;
        if ((x1) && (x1 != 0)) {
            var y1: number = +x1;
            this.graphData.ops_Drilled_Cooper_Target = y1;
        } else if (x1 == 0) {
            this.graphData.ops_Drilled_Cooper_Target = null;
        }

        var x2 = this.graphData.ops_Drilled_Cooper_LastYear;
        if ((x2) && (x2 != 0)) {
            var y2: number = +x2;
            this.graphData.ops_Drilled_Cooper_LastYear = y2;
        } else if (x2 == 0) {
            this.graphData.ops_Drilled_Cooper_LastYear = null;
        }

        var x3 = this.graphData.ops_Drilled_Cooper_Jan;
        if ((x3) && (x3 != 0)) {
            var y3: number = +x3;
            this.graphData.ops_Drilled_Cooper_Jan = y3;
        } else if (x3 == 0) {
            this.graphData.ops_Drilled_Cooper_Jan = null;
        }

        var x4 = this.graphData.ops_Drilled_Cooper_Feb;
        if ((x4) && (x4 != 0)) {
            var y4: number = +x4;
            this.graphData.ops_Drilled_Cooper_Feb = y4;
        } else if (x4 == 0) {
            this.graphData.ops_Drilled_Cooper_Feb = null;
        }

        var x5 = this.graphData.ops_Drilled_Cooper_Mar;
        if ((x5) && (x5 != 0)) {
            var y5: number = +x5;
            this.graphData.ops_Drilled_Cooper_Mar = y5;
        } else if (x5 == 0) {
            this.graphData.ops_Drilled_Cooper_Mar = null;
        }

        var x6 = this.graphData.ops_Drilled_Cooper_Apr;
        if ((x6) && (x6 != 0)) {
            var y6: number = +x6;
            this.graphData.ops_Drilled_Cooper_Apr = y6;
        } else if (x6 == 0) {
            this.graphData.ops_Drilled_Cooper_Apr = null;
        }

        var x7 = this.graphData.ops_Drilled_Cooper_May;
        if ((x7) && (x7 != 0)) {
            var y7: number = +x7;
            this.graphData.ops_Drilled_Cooper_May = y7;
        } else if (x7 == 0) {
            this.graphData.ops_Drilled_Cooper_May = null;
        }

        var x8 = this.graphData.ops_Drilled_Cooper_Jun;
        if ((x8) && (x8 != 0)) {
            var y8: number = +x8;
            this.graphData.ops_Drilled_Cooper_Jun = y8;
        } else if (x8 == 0) {
            this.graphData.ops_Drilled_Cooper_Jun = null;
        }

        var x9 = this.graphData.ops_Drilled_Cooper_Jul;
        if ((x9) && (x9 != 0)) {
            var y9: number = +x9;
            this.graphData.ops_Drilled_Cooper_Jul = y9;
        } else if (x9 == 0) {
            this.graphData.ops_Drilled_Cooper_Jul = null;
        }

        var x10 = this.graphData.ops_Drilled_Cooper_Aug;
        if ((x10) && (x10 != 0)) {
            var y10: number = +x10;
            this.graphData.ops_Drilled_Cooper_Aug = y10;
        } else if (x10 == 0) {
            this.graphData.ops_Drilled_Cooper_Aug = null;
        }

        var x11 = this.graphData.ops_Drilled_Cooper_Sep;
        if ((x11) && (x11 != 0)) {
            var y11: number = +x11;
            this.graphData.ops_Drilled_Cooper_Sep = y11;
        } else if (x11 == 0) {
            this.graphData.ops_Drilled_Cooper_Sep = null;
        }

        var x12 = this.graphData.ops_Drilled_Cooper_Oct;
        if ((x12) && (x12 != 0)) {
            var y12: number = +x12;
            this.graphData.ops_Drilled_Cooper_Oct = y12;
        } else if (x12 == 0) {
            this.graphData.ops_Drilled_Cooper_Oct = null;
        }

        var x13 = this.graphData.ops_Drilled_Cooper_Nov;
        if ((x13) && (x13 != 0)) {
            var y13: number = +x13;
            this.graphData.ops_Drilled_Cooper_Nov = y13;
        } else if (x13 == 0) {
            this.graphData.ops_Drilled_Cooper_Nov = null;
        }

        var x14 = this.graphData.ops_Drilled_Cooper_Dec;
        if ((x14) && (x14 != 0)) {
            var y14: number = +x14;
            this.graphData.ops_Drilled_Cooper_Dec = y14;
        } else if (x14 == 0) {
            this.graphData.ops_Drilled_Cooper_Dec = null;
        }

        var x15 = this.graphData.ops_Drilled_GLNG_Target;
        if ((x15) && (x15 != 0)) {
            var y15: number = +x15;
            this.graphData.ops_Drilled_GLNG_Target = y15;
        } else if (x15 == 0) {
            this.graphData.ops_Drilled_GLNG_Target = null;
        }

        var x16 = this.graphData.ops_Drilled_GLNG_LastYear;
        if ((x16) && (x16 != 0)) {
            var y16: number = +x16;
            this.graphData.ops_Drilled_GLNG_LastYear = y16;
        } else if (x16 == 0) {
            this.graphData.ops_Drilled_GLNG_LastYear = null;
        }

        var x17 = this.graphData.ops_Drilled_GLNG_Jan;
        if ((x17) && (x17 != 0)) {
            var y17: number = +x17;
            this.graphData.ops_Drilled_GLNG_Jan = y17;
        } else if (x17 == 0) {
            this.graphData.ops_Drilled_GLNG_Jan = null;
        }

        var x18 = this.graphData.ops_Drilled_GLNG_Feb;
        if ((x18) && (x18 != 0)) {
            var y18: number = +x18;
            this.graphData.ops_Drilled_GLNG_Feb = y18;
        } else if (x18 == 0) {
            this.graphData.ops_Drilled_GLNG_Feb = null;
        }

        var x19 = this.graphData.ops_Drilled_GLNG_Mar;
        if ((x19) && (x19 != 0)) {
            var y19: number = +x19;
            this.graphData.ops_Drilled_GLNG_Mar = y19;
        } else if (x19 == 0) {
            this.graphData.ops_Drilled_GLNG_Mar = null;
        }

        var x20 = this.graphData.ops_Drilled_GLNG_Apr;
        if ((x20) && (x20 != 0)) {
            var y20: number = +x20;
            this.graphData.ops_Drilled_GLNG_Apr = y20;
        } else if (x20 == 0) {
            this.graphData.ops_Drilled_GLNG_Apr = null;
        }

        var x21 = this.graphData.ops_Drilled_GLNG_May;
        if ((x21) && (x21 != 0)) {
            var y21: number = +x21;
            this.graphData.ops_Drilled_GLNG_May = y21;
        } else if (x21 == 0) {
            this.graphData.ops_Drilled_GLNG_May = null;
        }

        var x22 = this.graphData.ops_Drilled_GLNG_Jun;
        if ((x22) && (x22 != 0)) {
            var y22: number = +x22;
            this.graphData.ops_Drilled_GLNG_Jun = y22;
        } else if (x22 == 0) {
            this.graphData.ops_Drilled_GLNG_Jun = null;
        }

        var x23 = this.graphData.ops_Drilled_GLNG_Jul;
        if ((x23) && (x23 != 0)) {
            var y23: number = +x23;
            this.graphData.ops_Drilled_GLNG_Jul = y23;
        } else if (x23 == 0) {
            this.graphData.ops_Drilled_GLNG_Jul = null;
        }

        var x24 = this.graphData.ops_Drilled_GLNG_Aug;
        if ((x24) && (x24 != 0)) {
            var y24: number = +x24;
            this.graphData.ops_Drilled_GLNG_Aug = y24;
        } else if (x24 == 0) {
            this.graphData.ops_Drilled_GLNG_Aug = null;
        }

        var x25 = this.graphData.ops_Drilled_GLNG_Sep;
        if ((x25) && (x25 != 0)) {
            var y25: number = +x25;
            this.graphData.ops_Drilled_GLNG_Sep = y25;
        } else if (x25 == 0) {
            this.graphData.ops_Drilled_GLNG_Sep = null;
        }

        var x26 = this.graphData.ops_Drilled_GLNG_Oct;
        if ((x26) && (x26 != 0)) {
            var y26: number = +x26;
            this.graphData.ops_Drilled_GLNG_Oct = y26;
        } else if (x26 == 0) {
            this.graphData.ops_Drilled_GLNG_Oct = null;
        }

        var x27 = this.graphData.ops_Drilled_GLNG_Nov;
        if ((x27) && (x27 != 0)) {
            var y27: number = +x27;
            this.graphData.ops_Drilled_GLNG_Nov = y27;
        } else if (x27 == 0) {
            this.graphData.ops_Drilled_GLNG_Nov = null;
        }

        var x28 = this.graphData.ops_Drilled_GLNG_Dec;
        if ((x28) && (x28 != 0)) {
            var y28: number = +x28;
            this.graphData.ops_Drilled_GLNG_Dec = y28;
        } else if (x28 == 0) {
            this.graphData.ops_Drilled_GLNG_Dec = null;
        }

        var x29 = this.graphData.ops_Drilled_Max;
        if ((x29) && (x29 != 0)) {
            var y29: number = +x29;
            this.graphData.ops_Drilled_Max = y29;
        } else if (x29 == 0) {
            this.graphData.ops_Drilled_Max = null;
        }
    }
}